// IE 2026 10 30 / ODOO-345618 (apply_branch: conflict override dialog)
// Слияние ветки в родителя (apply_branch) бэк отклоняет, если строки родителя изменились после ветвления; в ответе — answer.branch_conflicts
// {version, title, count, rows:[{segment, id, title, by}] (≤20), log}. Фронт показывает диалог «Apply anyway (branch wins)?» и при согласии
// повторяет ту же команду с params.conflict_override = true. Выключатель fe.ux.branchApplyConflictDialog (дефолт ВКЛ; выкл — остаётся тост ошибки).
// Чистые функции — tests/unit/branchApplyConflict.test.mjs
export const BRANCH_CONFLICT_FLAG = 'fe.ux.branchApplyConflictDialog'
export const BRANCH_CONFLICT_MAX_ROWS = 5

// флаг (нет читателя / ошибка — ВКЛ)
export function branchConflict_on(setting) {
    try { return typeof setting === 'function' ? setting(BRANCH_CONFLICT_FLAG, true) !== false : true } catch (e) { return true }
}

// ответ бэка → null | {count, title, rows, log}; setting — читатель флагов (k, d) => value (необязателен)
export function branchConflict_fromAnswer(answer, setting) {
    if (!branchConflict_on(setting)) return null
    const bc = answer && typeof answer === 'object' ? answer.branch_conflicts : null
    if (!bc || typeof bc !== 'object') return null
    const rows = Array.isArray(bc.rows) ? bc.rows.filter(r => r && typeof r === 'object') : []
    const n = Number(bc.count)
    const count = Number.isFinite(n) && n > 0 ? Math.floor(n) : rows.length
    if (!count) return null
    return { count, title: bc.title == null ? '' : String(bc.title), rows, log: bc.log == null ? '' : bc.log }
}

// текст диалога; t(key, params) — переводчик (нет — подстановка {x} вручную)
export function branchConflict_message(info, t) {
    const tr = typeof t === 'function' ? t : (k, p) => String(k).replace(/\{(\w+)\}/g, (m, x) => (p && p[x] != null ? p[x] : m))
    const head = tr('Branch "{title}": {count} conflict(s) — parent rows changed after branching. Apply anyway (branch wins)?', { title: info.title, count: info.count })
    const rows = Array.isArray(info.rows) ? info.rows : []
    const lines = rows.slice(0, BRANCH_CONFLICT_MAX_ROWS).map(r => [r.segment, r.id, r.title].map(x => (x == null ? '' : String(x))).join(' · '))
    const more = Math.max(Number(info.count) || 0, rows.length) - lines.length
    if (more > 0) lines.push(tr('… and {n} more', { n: more }))
    return lines.length ? head + '\n' + lines.join('\n') : head
}

// копия action для повтора: params.conflict_override = true, подтверждение снято (оно уже было); исходный action не меняется
export function branchConflict_retryAction(action) {
    const a = { ...(action || {}) }
    delete a.confirm
    delete a.confirm_input
    delete a._confirm_accepted
    a.params = { ...(a.params || {}), conflict_override: true }
    return a
}
